import i18n from "@/i18n";
import { CreditRequestStates } from "../data/enums/creditRequestStates";

/**Состояние кредита */
export default function creditRequestState(creditRequestState: CreditRequestStates): string {
  let state: string = "";
  switch (creditRequestState) {
    case CreditRequestStates.UnderConsideration:
      state = i18n.t("main.creditRequest.states.underConsideration").toString();
      break;
    case CreditRequestStates.Approved:
      state = i18n.t("main.creditRequest.states.approved").toString();
      break;
    case CreditRequestStates.Canceled:
      state = i18n.t("main.creditRequest.states.canceled").toString();
      break;
    case CreditRequestStates.DocsPreparing:
      state = i18n.t("main.creditRequest.states.docsPreparing").toString();
      break;
    case CreditRequestStates.DocsPrepared:
      state = i18n.t("main.creditRequest.states.docsPrepared").toString();
      break;
    case CreditRequestStates.AwaitToIssued:
      state = i18n.t("main.creditRequest.states.awaitToIssued").toString();
      break;
    case CreditRequestStates.NeedToOffice:
      state = i18n.t("main.creditRequest.states.needToOffice").toString();
      break;
    default:
      state = "";
      break;
  }

  return state;
}
